import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import { mapState } from "vuex";
export default {
  computed: _objectSpread({}, mapState("d2admin/user", ["info"])),
  name: "commonProblemModal",
  data: function data() {
    return {
      form: {
        categoryZh: "",
        categoryEn: "",
        categoryTw: "",
        sort: ""
      },
      dialogVisible: false,
      rules: {
        categoryZh: [{
          required: true,
          message: "请输入中文名称",
          trigger: "blur"
        }],
        categoryEn: [{
          required: true,
          message: "请输入英文名称",
          trigger: "blur"
        }],
        categoryTw: [{
          required: true,
          message: "请输入繁体名称",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    show: function show(row) {
      this.form = row ? JSON.parse(JSON.stringify(row)) : {};
      this.dialogVisible = true;
    },
    save: function save() {
      var _this = this;
      this.$refs.ruleForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var res, text;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!valid) {
                  _context.n = 5;
                  break;
                }
                res = null;
                text = _this.form.id ? "更新成功" : "新增成功";
                if (!_this.form.id) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return _this.$api.updateFaqInfo(_this.form);
              case 1:
                res = _context.v;
                _context.n = 4;
                break;
              case 2:
                _this.form.createBy = _this.info.name;
                _context.n = 3;
                return _this.$api.addFaqInfo(_this.form);
              case 3:
                res = _context.v;
              case 4:
                if (res.data) {
                  _this.dialogVisible = false;
                  _this.$message.success(text);
                  _this.$emit("save");
                }
                _context.n = 6;
                break;
              case 5:
                return _context.a(2, false);
              case 6:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    close: function close() {
      this.$refs.ruleForm.clearValidate();
    }
  }
};